const carouselItems = [
  {
    tag: '本周热映',
    title: '《幕后玩家》· 金融悬疑烧脑力作',
    desc: '徐峥主演口碑黑马，一场关乎生死与金钱的密室博弈，豆瓣7.8分，全程高能无尿点。',
    img: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20thriller%20cinematic%20scene%20with%20a%20mysterious%20businessman%20silhouette%20against%20city%20night%20skyline%2C%20dramatic%20warm%20golden%20and%20deep%20shadow%20contrast%2C%20modern%20office%20interior%20with%20blinds%20casting%20striped%20shadows%2C%20film%20noir%20aesthetic%2C%20high%20tension%20mood%2C%20cinematic%20lighting%2C%20simple%20dark%20background&width=800&height=450&seq=tangxin-carousel-01&orientation=landscape',
  },
  {
    tag: '新番速递',
    title: '《繁花》· 王家卫首部电视剧',
    desc: '胡歌马伊琍主演，上海滩九十年代风云故事，画面美学极致，国产剧新标杆。',
    img: 'https://readdy.ai/api/search-image?query=A%20nostalgic%201990s%20Shanghai%20streetscape%20with%20warm%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20elegant%20vintage%20atmosphere%2C%20old%20shanghai%20restaurant%20interior%20with%20warm%20glowing%20lanterns%2C%20cinematic%20wong%20kar%20wai%20style%20color%20palette%2C%20rich%20amber%20and%20emerald%20tones%2C%20simple%20background&width=800&height=450&seq=tangxin-carousel-02&orientation=landscape',
  },
  {
    tag: '口碑推荐',
    title: '《漫长的季节》· 年度剧王',
    desc: '豆瓣9.4分封神之作，跨越二十年东北往事，范伟秦昊演技炸裂，必看神作。',
    img: 'https://readdy.ai/api/search-image?query=An%20atmospheric%20northern%20Chinese%20industrial%20town%20in%20autumn%20with%20warm%20golden%20foliage%2C%20old%20factory%20buildings%20and%20railway%20tracks%2C%20soft%20nostalgic%20afternoon%20sunlight%2C%20melancholic%20yet%20beautiful%20mood%2C%20cinematic%20wide%20composition%2C%20rich%20warm%20earth%20tones%2C%20simple%20natural%20background&width=800&height=450&seq=tangxin-carousel-03&orientation=landscape',
  },
  {
    tag: '综艺热播',
    title: '《奔跑吧》最新季 · 欢笑回归',
    desc: '国民综艺全新一季火热上线，原班人马爆笑回归，每周更新欢乐不间断。',
    img: 'https://readdy.ai/api/search-image?query=A%20bright%20energetic%20outdoor%20park%20scene%20with%20warm%20sunlight%20filtering%20through%20trees%2C%20colorful%20team%20game%20equipment%2C%20cheerful%20summer%20vibe%2C%20green%20grass%20and%20blue%20sky%2C%20fun%20recreational%20atmosphere%2C%20vibrant%20casual%20photography%2C%20simple%20natural%20background&width=800&height=450&seq=tangxin-carousel-04&orientation=landscape',
  },
  {
    tag: '纪录片',
    title: '《地球脉动III》· 视觉盛宴',
    desc: 'BBC史诗级自然纪录片最新季，4K超高清拍摄，每一帧都是壁纸级别的震撼。',
    img: 'https://readdy.ai/api/search-image?query=A%20stunning%20aerial%20view%20of%20pristine%20wilderness%20with%20golden%20sunrise%20light%20over%20snowcapped%20mountains%2C%20crystal%20clear%20lake%20reflecting%20the%20landscape%2C%20dramatic%20clouds%20in%20warm%20colors%2C%20epic%20nature%20documentary%20style%2C%20breathtaking%20landscape%20photography%2C%20simple%20natural%20background&width=800&height=450&seq=tangxin-carousel-05&orientation=landscape',
  },
  {
    tag: '经典重温',
    title: '《肖申克的救赎》· 永恒经典',
    desc: 'IMDb排名第一的传世之作，关于希望与自由的永恒主题，值得一遍又一遍回味。',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20with%20warm%20golden%20sunlight%20breaking%20through%20dark%20clouds%20over%20a%20quiet%20coastal%20landscape%2C%20symbolic%20of%20hope%20and%20freedom%2C%20peaceful%20ocean%20horizon%2C%20soft%20warm%20light%20rays%2C%20cinematic%20inspirational%20mood%2C%20rich%20golden%20and%20blue%20tones%2C%20simple%20natural%20background&width=800&height=450&seq=tangxin-carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
            编辑精选
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            焦点速递
          </h2>
          <p className="text-foreground-500 text-sm mt-2">本周最值得关注的影视内容，编辑团队精心挑选</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors duration-300"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}